<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .overlay {
    width: 40rem;
    min-width: 40%;
    height: 100%;
    overflow: auto;

    &.outreach {
      background-image: url("/assets/img/marketing/masks/outreach.svg");
    }
    &.calls {
      background-image: url("/assets/img/marketing/masks/conversations.svg");
    }
    &.search {
      background-image: url("/assets/img/marketing/masks/aiSearch.svg");
    }

    background-size: cover;

    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>

<script>
  // @ts-check
  import { onMount } from "svelte";
  import { fly } from "svelte/transition";
  import { getMarketingPageContext } from "./context.svelte";
  import Calls from "./Slides/Calls.svelte";
  import Campaigns from "./Slides/Campaigns.svelte";
  import Dashboard from "./Slides/Dashboard.svelte";
  import Outbox from "./Slides/Outbox.svelte";
  import Reports from "./Slides/Reports.svelte";
  import Search from "./Slides/Search.svelte";
  import Todo from "./Slides/Todo.svelte";

  const ctx = getMarketingPageContext();

  const maskMap = {
    "/search": "search",
    "/search-results": "search",
    "/calls": "calls",
    "/call": "calls",
  };
  let cls = $derived(maskMap[ctx.page] || "outreach");
  let display = $state(false);
  onMount(() => {
    display = true;
  });
</script>

{#if display}
  <div class="overlay {cls}" transition:fly={{ x: 1000, duration: 1000 }}>
    {#if ctx.page === "/dashboard"}
      <Dashboard />
    {:else if ctx.page === "/reports"}
      <Reports />
    {:else if ["/campaigns", "/campaign"].includes(ctx.page)}
      <Campaigns />
    {:else if ctx.page === "/todo"}
      <Todo />
    {:else if ctx.page === "/outbox"}
      <Outbox />
    {:else if ["/calls", "/call"].includes(ctx.page)}
      <Calls />
    {:else if ["/search", "/search-results"].includes(ctx.page)}
      <Search />
    {/if}
  </div>
{/if}
